import { HTTPMethod } from '@splunk/olly-services';
import { Endpoint } from '@splunk/olly-common/RBAC';

type EndpointsType =
    | 'viewIMMUsageTab'
    | 'viewIMMUsageReportsModal'
    | 'viewLOUsageTab'
    | 'viewOrgUsageExceedBanner';

export const orgUsageFeaturesEndpointMap: Record<EndpointsType, Endpoint[]> = {
    viewIMMUsageTab: [
        {
            path: '/v2/organization/imm/usage_details',
            httpMethod: HTTPMethod.GET,
        },
    ],
    viewIMMUsageReportsModal: [
        {
            path: '/v2/organization/usage-reports',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/organization/usage-reports/daily',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/organization/impact-reports',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/organization/usage-reports/hourly',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/organization/usage-reports/dpd',
            httpMethod: HTTPMethod.GET,
        },
    ],
    viewLOUsageTab: [
        {
            path: '/v2/organization/log-observer-reports/usage_details',
            httpMethod: HTTPMethod.GET,
        },
    ],
    viewOrgUsageExceedBanner: [
        {
            path: '/v2/organization/_/org-limits-list',
            httpMethod: HTTPMethod.GET,
        },
    ],
};
